import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Loader from '../../CommonComponents/Loader';
import Navbar from '../../CommonComponents/Navbar/Navbar';
import SavedComparisonsSidebar from '../../CommonComponents/SavedComparisonsSidebar/SavedComparisonsSidebar';
import WelcomeModal from '../../CommonComponents/WelcomeModal';
import { useOneTimeModal } from '../../CommonFuctions/useOneTimeModal';
import { DOC_COMPARE, WELCOME_MODAL_DOC_COMPARE } from '../../Constants/commonConstants';
import { getSavedComparisons } from '../../Redux/FileCompare/fileCompareActions';
import { useBackToID } from '../../utils/hooks/useBackToID';
import FilePicker from '../FilePicker/FilePicker';

let timerId = null;

function Dashboard() {
  const dispatch = useDispatch();
  const { savedComparisons } = useSelector((state) => state.compareData);
  const [isLoaderOpen, setIsLoaderOpen] = useState(true);

  const { clearBackPath } = useBackToID(DOC_COMPARE);

  const { modalOpen: docCompareWelcomeModalOpen, closeModal: closeDocCompareWelcomeModal } =
    useOneTimeModal(WELCOME_MODAL_DOC_COMPARE, { delay: 2000 });

  // Clear stored back path when returning to dashboard
  useEffect(() => {
    localStorage.setItem('product', 'doccompare');
    clearBackPath();
  }, [clearBackPath]);

  useEffect(() => {
    if (Object.keys(savedComparisons)?.length === 0) {
      dispatch(getSavedComparisons());
    }
    if (Object.keys(savedComparisons)?.length > 0) {
      setIsLoaderOpen(false);
    } else {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        setIsLoaderOpen(false);
      }, 1000);
    }
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  return (
    <div className='dashboard-container'>
      <WelcomeModal
        open={docCompareWelcomeModalOpen}
        variant='DocCompare'
        onCtaClick={closeDocCompareWelcomeModal}
      />
      <Navbar product={DOC_COMPARE} />
      {isLoaderOpen && <Loader time='200' />}
      <section className='flex'>
        <SavedComparisonsSidebar savedComparisons={savedComparisons} from='dashboard' />
        <FilePicker />
      </section>
    </div>
  );
}

export default Dashboard;
